<template>
  <div class="smart-exercises-filters">
    <v-spacer/>
    Show:
    <v-btn-toggle
        v-model="filter"
        borderless
        color="accent"
        rounded
        mandatory
        class="mr-8 ml-2"
      >
      <v-btn
        text
        value="all"
        @click="onInput('filter', 'all')"
      >
        <span>All</span>
      </v-btn>
      <v-btn
        text
        value="imported"
        @click="onInput('filter', 'imported')"
      >
        <span>Imported</span>
      </v-btn>
      <v-btn
        text
        value="not_imported"
        @click="onInput('filter', 'not_imported')"
      >
        <span>Not imported</span>
      </v-btn>
      <v-btn
        text
        value="partially_imported"
        @click="onInput('filter', 'partially_imported')"
        :disabled="isDisabled"
      >
        <span>Partially imported</span>
      </v-btn>
    </v-btn-toggle>
    Sort direction:
    <v-btn-toggle
        v-model="sortDirection"
        borderless
        color="accent"
        rounded
        mandatory
        class="mr-8 ml-2"
      >
      <v-btn
        text
        value="desc"
        @click="onInput('sortDirection', 'desc')"
      >
        <span>Newest</span>
      </v-btn>
      <v-btn
        text
        value="asc"
        @click="onInput('sortDirection', 'asc')"
      >
        <span>Oldest</span>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>
<script>
import { debounce } from "@/helpers/debounce"
export default {
  name: "SmartExercisesFilters",
  props: {
    queryParams: {
      type: Object,
      default: ()=>{}
    }
  },
  data: () => ({
    tmpValue: '',
    filter: 'all',
    sortDirection: 'desc',
    isDisabled: false
  }),
  mounted() {
    this.filter = this.queryParams?.filter || 'all'
    this.sortDirection = this.queryParams?.sortBy || 'desc'
  },
  watch: {
    $route(to) {
      this.isDisabled = !!to.query.folderId && to.query.filter !== 'partially_imported';
    }
  },
  methods: {
    clearSearch() {
      this.tmpValue = ''
      this.$emit('search-on:clear')
    },
    runSearch() {
      if (this.tmpValue)
        this.$emit('search-run', this.tmpValue)
    },
    onInput (key, value) {
      this.tmpValue = value
      debounce(() => {
        this.$emit('search-on:input', { key, value })
      },1000, 'SmartExercisesFilters')
    }
  }
};
</script>
<style lang="scss">
.smart-exercises-filters {
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: flex-start;
  .v-btn {
    width: auto;
    min-width: 80px !important;
    &.active {
      background: $bh-blue !important;
      .hidden {
        color: $bh-white;
      }
      .v-icon {
        &::before {
          color: $bh-white;
        }
      }
      small {
        color:$bh-white;
      }
    }
    &.transparent {
      background: transparent !important;
    }
    &--disabled {
      opacity: 0.3;
    }
  }
}
.bh-input-pill {
  margin: 0 8px !important;
  width: 264px;
  height: 48px !important;

  .v-input__slot {
    align-items: center;
    height: 48px;
    min-height: 0 !important;
    background:$bh-gray--6 !important;

    &::before,
    &::after {
      content: "";
      display: none;
    }

    .v-input__append-inner {
      align-self: center;
      margin-top: 0 !important;
    }

    .v-icon {
      color: $bh-blue;
    }
  }
}
</style>
